import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DropdownButton } from '@components/common';

import { AuthSelectors } from '@redux/AuthRedux';
import { transfromPropertyToAddress } from '@services/transform';
import { ALL_PROPETY } from '@services/minte';

function PropertySelect(props) {
  const { properties, value, allowAll, ...restProps } = props;

  let propertyOptions = properties;

  const isDisabled = !properties || properties.length < 2;

  if (allowAll && !isDisabled) {
    propertyOptions = propertyOptions.concat([ALL_PROPETY]);
  }

  return (
    <DropdownButton
      isSearchable={false}
      value={value}
      isDisabled={isDisabled}
      options={propertyOptions}
      placeholder="All Properties"
      getOptionValue={option => option.propertyID}
      getOptionLabel={transfromPropertyToAddress}
      {...restProps}
    />
  );
}

PropertySelect.propTypes = {
  properties: PropTypes.array,
  value: PropTypes.object,
  allowAll: PropTypes.bool
};

const mapStatesToProps = state => ({
  properties: AuthSelectors.selectUserProperties(state)
});

export default connect(mapStatesToProps)(PropertySelect);
